import React from 'react';
import { Plus } from 'lucide-react';

export interface GsHeaderProps {
  pageTitle: string;
  onAddClick?: () => void;
  addButtonLabel?: string;
  trailingSlot?: React.ReactNode;
}

export function GsHeader({ onAddClick, addButtonLabel, trailingSlot }: GsHeaderProps) {
  const showActions = trailingSlot != null || onAddClick != null;

  // Modèle D — pas de titre dans le header
  // bg-slate-50 light / dark:bg-slate-900 dark — filet bottom
  if (!showActions) {
    return (
      <div className="h-px shrink-0 bg-slate-200 dark:bg-slate-800" />
    );
  }

  return (
    <header className="flex h-10 min-h-10 shrink-0 items-center justify-end px-5
                       bg-page dark:bg-slate-900
                       border-b border-slate-200 dark:border-slate-800">
      <div className="flex shrink-0 items-center gap-2">
        {trailingSlot}
        {onAddClick != null && (
          <button
            type="button"
            onClick={() => onAddClick()}
            className="inline-flex h-7 items-center justify-center rounded-md
                       border border-brand-200 bg-brand-50 px-2.5
                       text-meta font-medium text-brand-700
                       transition-colors hover:bg-brand-100
                       dark:border-brand-900/40 dark:bg-brand-950/40 dark:text-brand-300"
            title="Ajouter"
          >
            {addButtonLabel != null && addButtonLabel !== '+' ? (
              addButtonLabel
            ) : (
              <Plus className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} />
            )}
          </button>
        )}
      </div>
    </header>
  );
}
